
import React, { useState } from "react";
import {
  Button,
  Card,
  CardTitle,
  CardBody,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";
import axiosInstance from "../../Request";
import { useParams } from "react-router-dom";
import { URL } from "../../api"; // ✅ Import centralized URLs

const PayoutCredit = () => {
  const { lid } = useParams();
  const [modalOpen, setModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("1");

  const [payoutHistory, setPayoutHistory] = useState([]);
  const [statusHistory, setStatusHistory] = useState([]);
  const [orderHistory, setOrderHistory] = useState([]);
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [disbursalHistory, setDisbursalHistory] = useState([]);

  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState({
    history: false,
    status: false,
    order: false,
    payment: false,
    disbursal: false,
  });

  const fetchData = async (type) => {
    setLoading(true);
    try {
      let url = "";
      switch (type) {
        case "history":
          url = `${URL.PAYOUT_HISTORY}?leadId=${lid}`;
          const historyRes = await axiosInstance.get(url);
          setPayoutHistory(historyRes.data);
          break;
        case "status":
          url = `${URL.PAYOUT_STATUS}?leadId=${lid}`;
          const statusRes = await axiosInstance.get(url);
          setStatusHistory(statusRes.data);
          break;
        case "order":
          url = `${URL.PAYOUT_ORDER}?leadId=${lid}`;
          const orderRes = await axiosInstance.get(url);
          setOrderHistory(orderRes.data);
          break;
        case "payment":
          url = `${URL.PAYOUT_PAYMENT}?leadId=${lid}`;
          const paymentRes = await axiosInstance.get(url);
          setPaymentHistory(paymentRes.data);
          break;
        case "disbursal":
          url = `${URL.PAYOUT_DISBURSEL}?leadId=${lid}`;
          const disbursalRes = await axiosInstance.get(url);
          setDisbursalHistory(disbursalRes.data);
          break;
        default:
          break;
      }
      setLoaded((prev) => ({ ...prev, [type]: true }));
    } catch (error) {
      console.error(`Error fetching ${type}:`, error);
      alert(`Failed to fetch ${type} data.`);
    }
    setLoading(false);
  };

  const toggleModal = () => {
    const opening = !modalOpen;
    setModalOpen(opening);

    if (opening) {
      setActiveTab("1");
      setLoaded({
        history: false,
        status: false,
        order: false,
        payment: false,
        disbursal: false,
      });
      setPayoutHistory([]);
      setStatusHistory([]);
      setOrderHistory([]);
      setPaymentHistory([]);
      setDisbursalHistory([]);
      fetchData("history");
    }
  };

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      if (!loaded[type]) {
        fetchData(type);
      }
    }
  };

  const renderTable = (data) => {
    if (loading) {
      return (
        <div className="text-center my-3">
          <Spinner color="primary" />
        </div>
      );
    }

    if (!data || data.length === 0) {
      return <p>No records found.</p>;
    }

    return (
      <table className="table table-bordered table-hover" style={{ minWidth: "800px" }}>
        <thead>
          <tr>
            {Object.keys(data[0])
              .filter((key) => key !== "descriptionJson" && key !== "description")
              .map((key, index) => (
                <th key={index}>{key}</th>
              ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, i) => (
            <tr key={i}>
              {Object.entries(row)
                .filter(([key]) => key !== "descriptionJson" && key !== "description")
                .map(([key, value], j) => (
                  <td key={j}>{value !== null ? value : "-"}</td>
                ))}
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return (
    <>
      <Col xs="6" sm="4" md="3">
        <Card className="card-stats mb-4">
          <CardBody>
            <Row>
              <div className="col">
                <CardTitle tag="h5" className="text-uppercase text-muted mb-0">
                  Payout
                </CardTitle>
                <span
                  className="h2 font-weight-bold mb-0 text-primary"
                  onClick={toggleModal}
                  role="button"
                  style={{ cursor: "pointer" }}
                >
                  View
                </span>
              </div>
            </Row>
          </CardBody>
        </Card>
      </Col>

      <Modal isOpen={modalOpen} toggle={toggleModal} size="xl">
        <ModalHeader toggle={toggleModal}>Payout</ModalHeader>
        <ModalBody style={{ overflowX: "auto" }}>
          <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "1" })}
                onClick={() => toggleTab("1", "history")}
              >
                Payout History
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "2" })}
                onClick={() => toggleTab("2", "status")}
              >
                Status
              </NavLink>
            </NavItem>
            {/* <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "3" })}
                onClick={() => toggleTab("3", "order")}
              >
                Order
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "4" })}
                onClick={() => toggleTab("4", "payment")}
              >
                Payment
              </NavLink>
            </NavItem> */}
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "5" })}
                onClick={() => toggleTab("5", "disbursal")}
              >
                Disbursal
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={activeTab} className="mt-3">
            <TabPane tabId="1">{renderTable(payoutHistory)}</TabPane>
            <TabPane tabId="2">{renderTable(statusHistory)}</TabPane>
            <TabPane tabId="3">{renderTable(orderHistory)}</TabPane>
            <TabPane tabId="4">{renderTable(paymentHistory)}</TabPane>
            <TabPane tabId="5">{renderTable(disbursalHistory)}</TabPane>
          </TabContent>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default PayoutCredit;
